<mat-sidenav-container>
    <!-- Main content -->
    <mat-sidenav-content class="admin-main-content">
      <app-top-navbar class="admin-top-navbar show-bare-branding" mode="condensed"></app-top-navbar>
  
      <router-outlet></router-outlet>
  
      <!-- Replacement for former mat-sidenav main menu -->
      <app-clarity-menu
        *ngIf="showClarityMenu"
        #clarityMenu
        class="use-active-item-line-decoration show-branding"
        [openStyle]="'fullscreen'"
        [fabCorner]="'bottom-right'"
        [showReasoningDropdown]="false"
        (openChange)="onMainMenuOpenChange($event)"
      >
      </app-clarity-menu>
    </mat-sidenav-content>
  
    <!-- Alt sidenav preserved exactly as before -->
    <mat-sidenav
      class="admin-alt-sidenav fixed-sidenav"
      #altSidenav
      mode="over"
      opened="false"
      position="end"
      (openedChange)="altSidenavToggled($event)"
    >
      <app-dynamic-menu></app-dynamic-menu>
    </mat-sidenav>
  </mat-sidenav-container>
  
